// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._O1H9NH0kUCir4S_Q_8k{text-decoration:none}.RAZQ2vUx4D96tgq8aI9C{width:109px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/quickLinks/ui/QuickLinkAction/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CAGF,sBACE,WAAA","sourcesContent":[".guideButton {\n  text-decoration: none;\n}\n\n.createButton {\n  width: 109px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guideButton": `_O1H9NH0kUCir4S_Q_8k`,
	"createButton": `RAZQ2vUx4D96tgq8aI9C`
};
export default ___CSS_LOADER_EXPORT___;
